module.exports = __webpack_public_path__ + "img/video.7def16b9.png";